import React, { Component } from 'react';
import axios from "axios";
import moment from 'moment';
import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

class Monedas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "Código",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width: 150,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Fecha Ultima Cotización",
                    id: "FUACotizacion",
                    accessor: d => moment(d.FUACotizacion, 'YYYY-MM-DDThh:mm:ssZ').format("DD-MM-YYYY hh:mm"),
                    show: true,
                },
                {
                    Header: "Cotizacion",
                    id: "Cotizacion",
                    accessor: d => d.Cotizacion,
                    show: true,
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                         onChange={event => onChange(event.target.value)}
                         style={{ width: "100%" }}
                         value={filter ? filter.value : ""}>
                         <option value="">TODOS</option>
                         <option value={"True"}>SI</option>
                         <option value={"False"}>NO</option>
                         </select>
                    ),
                    width: 100,
                    className:"text-center",
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                outerFilter={[{id:"DeBaja", lookup:"exact", value:"False"}]}
                apiUrl={api.gestion.generales.monedas}
                columns={this.state.columns}
                title={"Monedas"}
            />
        );
    }
}

export default Monedas;



// WEBPACK FOOTER //
// ./src/views/Gestion/Generales/Monedas/Monedas.js